import { Component, Vue } from "vue-property-decorator";
import { BASE_API_URL } from "../../utils/Constants";
import MediumAudience from "@/models/MediumAudience";

export const GET_ADMIN_MEDIUM_AUDIENCE = "get_medium_audience";
export const SAVE_ADMIN_MEDIUM_AUDIENCE = "save_medium_audience";
export const SAVE_MASSIVE_ADMIN_MEDIUM_AUDIENCE =
  "save_massive_medium_audience";
export const DELETE_ADMIN_MEDIUM_AUDIENCE = "delete_medium_audience";

@Component
export default class MediumAudienceMixin extends Vue {
  readonly adminMediumPath = BASE_API_URL + "admin/media/";
  readonly adminAudienceSuffix = "/medium_audiences";

  async getAdminMediaAudience(
    mediaId: string,
    page: number,
    term?: string
  ): Promise<MediumAudience[]> {
    let path =
      this.adminMediumPath +
      mediaId +
      this.adminAudienceSuffix +
      `?page=${page}&per=24`;
    if (term && term !== "") {
      path = path + `&filter[term]=${term}`;
    }
    return await this.$httpGet(path, GET_ADMIN_MEDIUM_AUDIENCE);
  }

  async putAdminMediumAudience(
    mediaId: string,
    payload: MediumAudience
  ): Promise<MediumAudience> {
    const formData = {
      value: payload.value,
    };
    return await this.$httpPut(
      this.adminMediumPath +
        mediaId +
        this.adminAudienceSuffix +
        `/${payload.id}`,
      SAVE_ADMIN_MEDIUM_AUDIENCE,
      formData
    );
  }

  async postMassiveMediumAudience(
    mediaId: string,
    payload: {
      audience: number;
      postalCode?: string;
      region?: string;
      district?: string;
      town?: string;
    }
  ): Promise<void> {
    const formData = {
      value: payload.audience,
      postal_code: payload.postalCode,
      region: payload.region,
      district: payload.district,
      town: payload.town,
    };
    await this.$httpPost(
      this.adminMediumPath + mediaId + this.adminAudienceSuffix + `/massive`,
      SAVE_MASSIVE_ADMIN_MEDIUM_AUDIENCE,
      formData
    );
  }

  async deleteAdminMediumAudience(
    mediaId: string,
    payload: string
  ): Promise<void> {
    const path =
      this.adminMediumPath + mediaId + this.adminAudienceSuffix + `/${payload}`;
    return await this.$httpDelete(path, DELETE_ADMIN_MEDIUM_AUDIENCE, {
      id: payload,
    });
  }
}
